import { AUTHENTICATED_PRICING_PATH } from "@/lib/platform/pricing-destination";

export type ExploreNavItem = {
  title: string;
  href: string;
};

/** Authenticated sidebar Explore tree — single source for labels and routes. */
export const EXPLORE_NAV_ITEMS: ExploreNavItem[] = [
  { title: "About", href: "/about" },
  { title: "Published", href: "/billing/published" },
  { title: "Feedback", href: "/chat" },
  { title: "Contact", href: "/contact" },
  { title: "Pricing", href: AUTHENTICATED_PRICING_PATH },
];

export function isExploreNavPath(pathname: string): boolean {
  return EXPLORE_NAV_ITEMS.some(
    (item) => pathname === item.href || pathname.startsWith(`${item.href}/`),
  );
}

export function isExploreNavItemActive(pathname: string, href: string): boolean {
  if (href === AUTHENTICATED_PRICING_PATH) {
    return pathname === href || pathname.startsWith(`${href}/`);
  }
  return pathname === href || pathname.startsWith(`${href}/`);
}
